"use strict";

/* A service / model */

_BannerFlowApp.factory("AuthInfo", function ($rootScope) {
    return {
        LoggedInUser: null,
        Roles: [],
        InvitableRoles: [],
        Logout: function () {
            window.open(window.HOME_URL + "/logout", "_self");
        },
        ChangeBrand: function (brand) {
            var account = _.find(this.LoggedInUser.accounts, function (a) {
                return _.any(a.brands, function (b) {
                    return b.id === brand.id;
                });
            });

            var brandSlug = brand.slug;
            var currentStateParts = $rootScope.$state.current.name.split(".");
            var parentStateName = currentStateParts[0] + "." + currentStateParts[1];
            var parentStateUrl = $rootScope.$state.href(parentStateName, {
                rootAccountId: account.slug,
                rootBrandId: brandSlug
            });
            window.open(parentStateUrl, "_self");
        },
        HasFeatures: function (features) {
            var self = this;

            if (!self.LoggedInUser) return false;

            for (var i = 0; i < features.length; i++) {
                var find = _.find(self.LoggedInUser.currentAccount.permissions, function (feature) {
                    return feature === features[i];
                });

                if (find) return true;
            }

            return false;
        },
        RestrictAccessByUserRoles: function (roles) {
            var self = this;

            if (self.LoggedInUser.isEmployee) {
                return true;
            }

            var result = roles.indexOf(self.LoggedInUser.role);
            if (result === -1) {
                return true;
            } else {
                return false;
            }
        },
        CanMove: function () {
            var self = this;
            if (self.LoggedInUser.isEmployee) {
                return true;
            }
            switch (self.LoggedInUser.role) {
                case $rootScope.PERMISSION_ROLE_TEXT_EDITOR:
                case $rootScope.PERMISSION_ROLE_TEXT_EDITOR_EXTENDED:
                case $rootScope.PERMISSION_ROLE_PUBLISHER:
                case $rootScope.PERMISSION_ROLE_ANALYZER:
                case $rootScope.PERMISSION_ROLE_TEXT_EDITOR_WITH_ANALYZER:
                case $rootScope.PERMISSION_ROLE_EXTERNAL_DESIGNER:
                case $rootScope.PERMISSION_ROLE_PUBLISHER_EXTENDED:
                    return false;
                    break;
                default:
                    return true;
                    break;
            }
        },
        CanUseCampaignManager: function () {
            var self = this;
            if (self.LoggedInUser.isEmployee) {
                return true;
            }
            switch (self.LoggedInUser.role) {
                case $rootScope.PERMISSION_ROLE_ADMIN:
                case $rootScope.PERMISSION_ROLE_USER:
                case $rootScope.PERMISSION_ROLE_EXTERNAL_USER:
                case $rootScope.PERMISSION_ROLE_PUBLISHER:
                case $rootScope.PERMISSION_ROLE_PUBLISHER_EXTENDED:
                    return true;
                default:
                    return false;
            }
        },
        CanLockItems: function () {
            var self = this;
            if (self.LoggedInUser.isEmployee) {
                return true;
            }
            switch (self.LoggedInUser.role) {
                case $rootScope.PERMISSION_ROLE_ADMIN:
                    return true;
                default:
                    return false;
            }
        },
        Init: function (data) {
            var self = this;
            if (!data) {
                return;
            }
            self.LoggedInUser = data.user;
            self.LoggedInUser.accounts = data.accounts;
            self.LoggedInUser.isEmployee = data.user.employee === 3;

            self.LoggedInUser.currentAccount =
                _.find(data.accounts, function (a) {
                    return a.current;
                }) || data.accounts[0];

            self.LoggedInUser.currentBrand = _.find(
                self.LoggedInUser.currentAccount.brands,
                function (br) {
                    return br.current;
                }
            );

            self.LoggedInUser.currentAccount.plan = self.LoggedInUser.currentAccount.plans[0];
            self.Roles = data.roles || [];

            self.Roles.push({
                role: $rootScope.PERMISSION_ROLE_OWNER,
                name: "Owner",
                accessAllBrands: true
            });

            self.InvitableRoles = _.filter(self.Roles, function (r) {
                return r.role != $rootScope.PERMISSION_ROLE_OWNER;
            });
        }
    };
});
